import { acceptHMRUpdate, defineStore } from 'pinia'
import type { BugReportParams } from '~/types/bugs'
import type { UploadableFile } from '~/utils/files/uploadableFile.ts'
import statusMessages from '/@lang/status-messages.json'
import snakecaseKeys from 'snakecase-keys'

// Don't remove, this prevents a duplicated `actions` import somehow
interface State {
  postedBugs: BugReportParams[]
}

const bugStatusMessages = statusMessages['bug-status-messages']

const { toast } = addToast()

export const useBugsStore = defineStore('bugs', {
  state: (): State => ({
    postedBugs: []
  }),
  actions: {
    async submitBugReport(
      content: File,
      screenshot: UploadableFile | null,
      descriptionData: BugReport,
      currentPath: string
    ): Promise<boolean> {
      try {
        const formData = new FormData()
        formData.append('zip', content)
        formData.append('screenshot', screenshot?.file ?? '')
        formData.append(
          'description_data',
          JSON.stringify(snakecaseKeys({ ...descriptionData, link: currentPath } as any))
        )

        await this.api.post('admin/bugs/submit', formData)
        toast.success(bugStatusMessages[this.currentLocale].success['create-bug'])
        return true
      } catch {
        toast.error(bugStatusMessages[this.currentLocale].error['create-bug'])
        return false
      }
    }
  },
  getters: {}
})

/**
 * Pinia supports Hot Module replacement, so you can edit your stores and
 * interact with them directly in your app without reloading the page.
 *
 * @see https://pinia.esm.dev/cookbook/hot-module-replacement.html
 * @see https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBugsStore as any, import.meta.hot))
}
